import { isValid } from 'date-fns';
/**
 * Convert a string to a date or undefined.
 *
 * Useful when you have an optional date as a text string and
 * you want to treat it as an optional `Date` in your code.
 */
export const optionalDate = (dateText) => {
    // Handle `null`, `undefined` and `''` as `undefined`.
    if (!dateText) {
        return undefined;
    }
    if (dateText instanceof Date) {
        return dateText;
    }
    /** The date parsed from the input string */
    const parsedDate = new Date(dateText);
    // Handle invalid dates as `undefined`.
    if (!isValid(parsedDate)) {
        return undefined;
    }
    // Handle `string` values being converted to `Date` objects.
    return parsedDate;
};
